export default __webpack_public_path__ + "media/images/wing_left-f897c1660cfb14be8b31a79121d1f2dc.png";